"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membersError = exports.receiveMembers = exports.receiveMembersStarted = exports.MEMBERS_ERROR = exports.RECEIVE_MEMBERS = exports.RECEIVE_MEMBERS_STARTED = void 0;
exports.default = reducer;
exports.loadMembers = loadMembers;
const api_1 = require("core/api");
const lodash_1 = require("lodash");
// Actions
exports.RECEIVE_MEMBERS_STARTED = 'RECEIVE_MEMBERS_STARTED';
exports.RECEIVE_MEMBERS = 'RECEIVE_MEMBERS';
exports.MEMBERS_ERROR = 'MEMBERS_ERROR';
// Reducer
const initialState = {
    membersLoaded: false,
    members: [],
    memberTeamIds: [],
    isCommissionerOfAnything: false,
    commissionerDivisionIds: [],
};
function reducer(state = initialState, action = {}) {
    const members = action.data;
    switch (action.type) {
        case 'RECEIVE_MEMBERS_STARTED':
            return {
                ...state,
            };
        case 'RECEIVE_MEMBERS':
            return {
                ...state,
                members: members,
                membersLoaded: true,
                memberTeamIds: (0, lodash_1.chain)(members).filter('teamId').map('teamId').join(',').value(),
                memberDivisionIds: (0, lodash_1.chain)(members).filter('divisionId').map('divisionId').join(',').value(),
                isCommissionerOfAnything: (0, lodash_1.some)(members, (m) => m.isCommissioner),
                commissionerDivisionIds: (0, lodash_1.chain)(members)
                    .filter((m) => m.isCommissioner && !!m.divisionId)
                    .map((m) => m.divisionId)
                    .value(),
            };
        case 'MEMBERS_ERROR':
            return {
                ...state,
                membersLoaded: true,
                error: action.error,
            };
        default:
            return state;
    }
}
// Action Creators
const receiveMembersStarted = () => {
    return {
        type: exports.RECEIVE_MEMBERS_STARTED,
    };
};
exports.receiveMembersStarted = receiveMembersStarted;
const receiveMembers = (data) => {
    return {
        type: exports.RECEIVE_MEMBERS,
        data,
    };
};
exports.receiveMembers = receiveMembers;
const membersError = (data) => {
    return {
        type: exports.MEMBERS_ERROR,
        data,
    };
};
exports.membersError = membersError;
// services
function loadMembers(user) {
    return (dispatch) => {
        if (!user)
            return;
        dispatch((0, exports.receiveMembersStarted)());
        return api_1.MemberService.getUserPersona()
            .then((res) => {
            if (res.error) {
                throw res.error;
            }
            dispatch((0, exports.receiveMembers)(res));
        })
            .catch((error) => {
            dispatch((0, exports.membersError)(error));
        });
    };
}
